import { Checkbox } from '@material-ui/core';
import FormGroup from '@material-ui/core/FormGroup';
import { createStyles, makeStyles, withStyles } from '@material-ui/styles';
import CustomizeIOSSwitch from 'component/customize_style_component/customize_ios_switch';
import React from 'react';
export const useStyles = makeStyles(() =>
    createStyles({
        container: {
            padding: '24px 24px',
        },
        settingContent: {
            marginBottom: 34,
        },
        settingSlider: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            margin: '6px 0',
        },
        settingAction: {
            fontSize: 16,
            fontWeight: 400,
            color: '#fff',
            fontFamily: 'PoppinsRegular',
            margin: 0,
        },
        settingTitle: {
            fontSize: 18,
            fontWeight: 500,
            color: '#fff',
            fontFamily: 'PoppinsRegular',
            marginBottom: 20,
        },
    }),
);

const CustomColorCheckbox = withStyles({
    root: {
        color: '#4A6C72',
        '&$checked': {
            color: '#4A6C72',
        },
    },
    checked: {},
})((props: any) => <Checkbox color="default" {...props} />);
function SettingContent(props) {
    const classes = useStyles();
    const [checked, setChecked] = React.useState<any>(true);
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setChecked(event.target.checked);
    };
    return (
        <div className={classes.container}>
            <div className={classes.settingContent}>
                <h3 className={classes.settingTitle}>Notification</h3>
                <div className={classes.settingSlider}>
                    <p className={classes.settingAction}>App</p>
                    <FormGroup>
                        <CustomizeIOSSwitch checked={checked} onChange={handleChange} name="checkedB" />
                    </FormGroup>
                </div>
                <div className={classes.settingSlider}>
                    <p className={classes.settingAction}>Email</p>
                    <FormGroup>
                        <CustomizeIOSSwitch checked={checked} onChange={handleChange} name="checkedB" />
                    </FormGroup>
                </div>
                <div className={classes.settingSlider}>
                    <p className={classes.settingAction}>WhatsApp</p>
                    <FormGroup>
                        <CustomizeIOSSwitch checked={checked} onChange={handleChange} name="checkedB" />
                    </FormGroup>
                </div>
            </div>
            <div className={classes.settingContent}>
                <h3 className={classes.settingTitle}>Type notifications</h3>
                <div className={classes.settingSlider}>
                    <p className={classes.settingAction}>Recommendations</p>
                    <CustomColorCheckbox checked={checked} onChange={handleChange} />
                </div>
                <div className={classes.settingSlider}>
                    <p className={classes.settingAction}>Order updates</p>
                    <CustomColorCheckbox checked={checked} onChange={handleChange} />
                </div>
                <div className={classes.settingSlider}>
                    <p className={classes.settingAction}>Availability updates</p>
                    <CustomColorCheckbox checked={checked} onChange={handleChange} />
                </div>
            </div>
        </div>
    );
}

export default SettingContent;
